import { ApiNotification } from '@/data'
import { APIRoute } from '@/modules/utils'

export type Body = {
  status: 'read'
}

export type Response = ApiNotification

export const Route = (notification: ApiNotification): APIRoute => ({
  path: notification['@id'],
  method: 'PUT',
})
